import React, { useState, useEffect } from 'react';
import { Checkbox, Form, Divider, Card } from 'antd';
import BeforePickupCancelRules from 'components/base/SPCancelRules/components/BeforePickup';
import WithServiceCancelRules from 'components/base/SPCancelRules/components/WithService';
import { useCancelRuleTemplate } from 'hooks/product-price/cancel-rule-template';

interface PropsType {
  value?: any;
  onChange?: any;
}

const TemplateSelect:React.FC<PropsType> = (props) => {
  const { value, onChange } = props || {};

  const { init } = useCancelRuleTemplate();

  const [dailyCancelRules, setDailyCancelRules] = useState([]);
  const [pickupCancelRules, setPickupCancelRules] = useState([]);


  const handleCheckboxChange = (value: any) => {
    onChange && onChange(value ? 1 : 2);
  }

  useEffect(() => {
    init({}).then((res: any) => {
      const { before_pickup_cancel_rules, free_cancel_or_pickup_home_cancel_rules } = res?.data?.weekday || {};
      setDailyCancelRules(before_pickup_cancel_rules || []);
      setPickupCancelRules(free_cancel_or_pickup_home_cancel_rules || []);
    })
    if (!value) {
      onChange && onChange(2);
    }
  }, []);

  return (
    <>
      <div style={{ marginBottom: 6, fontSize: '14px', fontWeight: 'bold' }}>
        平日取消规则 <span style={{ marginLeft: 12, fontSize: '12px', fontWeight: 'normal' }}>支付完成15分钟内免费取消</span>
      </div>
      <div style={{ padding: '20px 12px', border: '1px solid rgba(0, 0, 0, 0.15)', borderRadius: 6 }}>
        <Form.Item label=" "  colon={false} labelCol={{
          style: { width: '12px' }
        }}>
          <BeforePickupCancelRules dailyCancelRules={dailyCancelRules} />

          <Divider />

          <Checkbox style={{ marginBottom: 20 }} checked={value === 1} onChange={(e:any) => handleCheckboxChange(e.target.checked)}>
            免费接乘客到店取车/送车上门取消规则 （勾选后，免费接送/送车上门的平日订单，取消按以下规则执行，不勾选则所有订单平日都免费取消）
          </Checkbox>

          <WithServiceCancelRules pickupCancelRules={pickupCancelRules} />

        </Form.Item>
      </div>
    </>
  )
}

export default TemplateSelect;
